module.exports = __webpack_public_path__ + "img/g1@2x.c3de940f.png";